import { useEffect, useState } from 'react';
import { logout } from '../../auth';
import { get } from '../../services/api';
import { useNavigate } from 'react-router-dom';

import Select from 'react-select';
import AdminSection from "../AdminSection/AdminSection";
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect';
import CustomMultiSelectGroup from '../CustomMultiSelectGroup/CustomMultiSelectGroup'
import AdminTable from "../../components/AdminTable/AdminTable";

import './QuadroVendedores.css';
export default function QuadroVendedores({ setNotifier }) {
    const navigate = useNavigate();

    const [ authTokenState, setAuthTokenState ] = useState(null);

    const nomeMeses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';

    const selectStyle = { 
        control: (base, state) => ({
            ...base,
            background: "unset",
            borderColor: "#DCDCDC",
            borderRadius: "4px"
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }) 
    }

    const currentDate = new Date()
    function getMonth(monthIndex) {
        const accurateMonthIndex = monthIndex >= 0 ? monthIndex % 12 : 12 + monthIndex % 12
        return {
            label: nomeMeses[accurateMonthIndex],
            value: (accurateMonthIndex) + 1,
            ano: new Date().getFullYear() + Math.floor(monthIndex / 12)
        };
    };

    const optionsMes = [
        getMonth(currentDate.getMonth()),
        getMonth(currentDate.getMonth() + 1)
    ];

    const [ optionsCluster, setOptionsCluster ] = useState([]);
    const [ optionsRegiao, setOptionsRegiao ] = useState([]);
    const [ optionsFilial, setOptionsFilial ] = useState([]);

    const [ mesSelecionado, setMesSelecionado ] = useState(null);
    const [ anoSelecionado,setAnoSelecionado ] = useState(new Date().getFullYear());
    const [ filiaisSelecionadas, setFiliaisSelecionadas ] = useState(null);
    const [ clustersSelecionados, setClustersSelecionados ] = useState(null);
    const [ regioesSelecionadas, setRegioesSelecionadas ] = useState(null);

    const [ isSecondStageDisabled, setIsSecondStageDisabled ] = useState(true);
    const [ quadroVendedores, setQuadroVendedores ] = useState(null);
    const [ dados, setDados ] = useState([]);
    const tableData = {
        atributoKey: 'idfilial',
        colunas: [
            { nome: 'Filial', atributo: 'nome_filial' }, 
            { nome: 'Quadro Ideal', atributo: 'quadro_ideal' }, 
            { nome: 'Quadro Real', atributo: 'quadro_real' },
            { nome: 'Quadro Real Importação', atributo: 'quadro_real_importacao' }
        ],
        dados: dados
    };

    async function setOptionsClusterWithRequest(authToken) {
        try {
            const clusters = await get('/admin/metas/cluster', null, authToken)
            setOptionsCluster(clusters.map(cluster => ({ 
                label: cluster.cluster, 
                value: cluster.id_cluster 
            })))

            return clusters
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    async function setOptionsRegiaoWithRequest(authToken) {
        try {
            const regioes = await get('/admin/metas/regiao', null, authToken)
            setOptionsRegiao(regioes.map(regiao => ({ 
                label: regiao.nome_regiao, 
                value: regiao.id_regiao 
            })))

            return regioes
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    async function setOptionsFilialWithRequest(authToken) {
        try {
            const filiais = await get('admin/metas/filial', null, authToken)
            setOptionsFilial(filiais)

            return filiais
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    const buscaDesabilitada = ((clustersSelecionados === null || clustersSelecionados?.length === 0) 
            && (regioesSelecionadas === null || regioesSelecionadas?.length === 0) 
            && (filiaisSelecionadas === null || filiaisSelecionadas?.length === 0)
        )
        || mesSelecionado === null 
        || anoSelecionado === null;

    function limparFiltros() {
        setMesSelecionado(null);
        setAnoSelecionado(new Date().getFullYear());
        setRegioesSelecionadas(null);
        setClustersSelecionados(null);
        setFiliaisSelecionadas(null);
        setQuadroVendedores(null);
        setDados([]);
        setIsSecondStageDisabled(true);
    }

    //Utils
    function parseObjectToURLQuery(object) {
        return Object.keys(object).reduce(
            (accumulator, paramKey) => {
                if(object[paramKey]){
                    if(typeof object[paramKey] === 'object'){
                        return accumulator + object[paramKey].reduce((accumulator2, value) => accumulator2 + `&${paramKey}=${value}` , '')
                    }
                    else return accumulator + `&${paramKey}=${object[paramKey]}`
                }
                    
                else return accumulator
            }, '')
    }

    async function buscarDados() {
        try {
            const filtrosBusca = {
                id_clusters: clustersSelecionados,
                id_regioes: regioesSelecionadas,
                idfiliais: filiaisSelecionadas, 

                mes: mesSelecionado.value, 
                ano: anoSelecionado,

                page: 1
            };
            
            const quadrovendedores = await get(`/admin/quadrovendedores?${parseObjectToURLQuery(filtrosBusca)}`, null, authTokenState);

            setQuadroVendedores(quadrovendedores);
            setIsSecondStageDisabled(false);

        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    function popularDadosTabela() {
        try {
            if(quadroVendedores != null)  {

                setDados(quadroVendedores.map((quadrovendedor, index) => {
    
                    const row = {
        
                        nome_filial: quadrovendedor.nome_filial,
                        quadro_ideal: quadrovendedor.quadro_ideal,
                        quadro_real: quadrovendedor.quadro_real,
                        quadro_real_importacao: quadrovendedor.quadro_real_importacao
                    }
        
                    return row;
                }));
            }
        } catch (error) {
            setDados([]);
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken");

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }

        popularDadosTabela();

        setAuthTokenState(authToken);
        setOptionsClusterWithRequest(authToken);
        setOptionsRegiaoWithRequest(authToken);
        setOptionsFilialWithRequest(authToken);
    }, [ quadroVendedores ]);

    return <>
    <AdminSection
        etapa={1} titulo={'Selecione os filtros'} 
    >
        <div className='admin-filtros-dividos p-8'>
            <div className='admin-filtros-left'>

                <div>
                    <label htmlFor="mes">Selecione o período</label>
                    <Select
                        name="mes"
                        className="react-select"
                        classNamePrefix="react-select"
                        options={optionsMes}
                        value={mesSelecionado}
                        onChange={mes => { 
                            setMesSelecionado(mes)
                            setAnoSelecionado(mes.ano) 
                        }}
                        placeholder="Mês"
                        required
                        menuPortalTarget={document.body} 
                        styles={selectStyle}
                        isSearchable={false}
                        noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                    />
                </div>

                <div className='ano-wrapper'>
                    <input 
                        type='text' 
                        name='ano'
                        placeholder='Ano' 
                        value={anoSelecionado}
                        onChange={(value) => setAnoSelecionado(value.currentTarget.value)}
                        required
                        readOnly
                    />
                </div>

            </div>

            <div className='first-values-right' style={{paddingTop: '15px'}}>
                <div className='id_cluster-wrapper'>
                    <label htmlFor="id_cluster">Selecione o cluster</label>
                    <CustomMultiSelect
                        selectedOptions={clustersSelecionados}
                        setSelectedOptions={setClustersSelecionados}
                        filteredOptions={optionsCluster}
                        placeholder={'Cluster'}
                        disabled={
                            (regioesSelecionadas != null && regioesSelecionadas?.length > 0) || 
                            (filiaisSelecionadas != null && filiaisSelecionadas?.length > 0)
                        }
                    />
                </div>

                <span>ou</span>

                <div className='id_regiao-wrapper'>
                    <label htmlFor="id_regiao">Selecione a região</label>
                    <CustomMultiSelect
                        selectedOptions={regioesSelecionadas}
                        setSelectedOptions={setRegioesSelecionadas}
                        filteredOptions={optionsRegiao}
                        placeholder='Região'
                        disabled={
                            (clustersSelecionados != null && clustersSelecionados?.length > 0) || 
                            (filiaisSelecionadas != null && filiaisSelecionadas?.length > 0) 
                        }
                    />
                </div>

                <span>ou</span>

                <div className='idfiliais-wrapper'>
                    <label htmlFor="idfiliais">Selecione as filiais</label>
                    <CustomMultiSelectGroup
                        options={optionsFilial}
                        placeholder="Filiais"
                        selectedOptions={filiaisSelecionadas}
                        setSelectedOptions={setFiliaisSelecionadas}
                        className='input-idfiliais'
                        disabled={
                            (clustersSelecionados != null && clustersSelecionados?.length > 0) || 
                            (regioesSelecionadas != null && regioesSelecionadas?.length > 0)
                        }
                    />
                </div>

                <div className="manage-btns">
                    <button 
                        className="refresh-btn" 
                        onClick={limparFiltros}
                        disabled={buscaDesabilitada}>Limpar</button>
                    <button 
                        className="search-btn" 
                        onClick={buscarDados}
                        disabled={buscaDesabilitada}>Carregar</button>
                </div>

            </div>
        </div>

    </AdminSection>

    <AdminSection
        etapa={2} titulo={'Quadro de vendedores'} disabled={isSecondStageDisabled}
    >
        <AdminTable
            atributoKey={tableData.atributoKey}
            colunas={tableData.colunas}
            dados={tableData.dados}
            styleName={'tabela-quadro-vendedores'}
        />
    </AdminSection>
</>
}